module.exports = __webpack_public_path__ + "static/media/holiday-party-catering-2.30839329.jpg";